module.exports = __webpack_public_path__ + "media/images/news-1-e7ebd95daffc24103a27e13196a24826.jpg";